import React from 'react';
import ReactDOM from 'react-dom';
import { addLocaleData, IntlProvider } from 'react-intl';
import $ from 'jquery';
import App from './App';
import './index.css';
import messages from './messages.json';

import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';

addLocaleData([...en, ...es])


const locale = 'es';


ReactDOM.render(
  <IntlProvider locale={locale} messages={messages[locale]}>
    <App/>
  </IntlProvider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js